export default {
    getTasksIcon(icon) {
        return {
            tasksBlack: require('../../utilities/img/icons/tasks_black.png'),
            tasksGreen: require('../../utilities/img/icons/tasks_green.png'),
            tasksYellow: require('../../utilities/img/icons/tasks_yellow.png'),
            tasksRed: require('../../utilities/img/icons/tasks_red.png'),
            tasksBlue: require('../../utilities/img/icons/tasks_blue.png'), 
            tasksGrey: require('../../utilities/img/icons/tasks_grey.png'),
            tasksWhite: require('../../utilities/img/icons/tasks_white.png'),
            eventsBlack: require('../../utilities/img/icons/event_black.svg'),
            expensesBlack: require('../../utilities/img/icons/wallet_black.svg'),
            statisticsBlack: require('../../utilities/img/icons/statistics_black.svg'),
            unselectedBlack: require('../../utilities/img/icons/tab_unselected_black.svg'),
            copyBlack: require('../../utilities/img/icons/content_copy_black.svg'),
            photoCamera: require('../../utilities/img/icons/photo_camera_black.svg')
        }[icon];
    }
}